export default __webpack_public_path__ + "static/media/empty-set-grey.73ef1fd3.svg";